import { createContext } from 'react';

export const defaultApp = {
};

export const AppContext = createContext(defaultApp);
